import {createSlice} from '@reduxjs/toolkit'

const initialTradeShowState = {
  totalCount: 0,
  trade_shows: null,
  trade_show: undefined,
  trade_shows_dropdown: [],
}

export const TradeShowSlices = createSlice({
  name: 'trade_shows',
  initialState: initialTradeShowState,
  reducers: {
    trade_show: (state, action) => {
      state.trade_show = action.payload.trade_show
    },

    trade_shows: (state, action) => {
      state.trade_shows = action.payload.trade_shows
      state.totalCount = action.payload.total_count
    },

    trade_shows_dropdown: (state, action) => {
      state.trade_shows_dropdown = action.payload.trade_shows
    },
  },
})
